export default [
  {
    text: 'Afghanistan',
    value: 'Afghanistan',
    key: 'AF',
  },
  {
    text: 'Åland Islands',
    value: 'Åland Islands',
    key: 'AX',
  },
  {
    text: 'Albania',
    value: 'Albania',
    key: 'AL',
  },
  {
    text: 'Algeria',
    value: 'Algeria',
    key: 'DZ',
  },
  {
    text: 'American Samoa',
    value: 'American Samoa',
    key: 'AS',
  },
  {
    text: 'Andorra',
    value: 'Andorra',
    key: 'AD',
  },
  {
    text: 'Angola',
    value: 'Angola',
    key: 'AO',
  },
  {
    text: 'Anguilla',
    value: 'Anguilla',
    key: 'AI',
  },
  {
    text: 'Antarctica',
    value: 'Antarctica',
    key: 'AQ',
  },
  {
    text: 'Antigua and Barbuda',
    value: 'Antigua and Barbuda',
    key: 'AG',
  },
  {
    text: 'Argentina',
    value: 'Argentina',
    key: 'AR',
  },
  {
    text: 'Armenia',
    value: 'Armenia',
    key: 'AM',
  },
  {
    text: 'Aruba',
    value: 'Aruba',
    key: 'AW',
  },
  {
    text: 'Australia',
    value: 'Australia',
    key: 'AU',
  },
  {
    text: 'Austria',
    value: 'Austria',
    key: 'AT',
  },
  {
    text: 'Azerbaijan',
    value: 'Azerbaijan',
    key: 'AZ',
  },
  {
    text: 'Bahamas',
    value: 'Bahamas',
    key: 'BS',
  },
  {
    text: 'Bahrain',
    value: 'Bahrain',
    key: 'BH',
  },
  {
    text: 'Bangladesh',
    value: 'Bangladesh',
    key: 'BD',
  },
  {
    text: 'Barbados',
    value: 'Barbados',
    key: 'BB',
  },
  {
    text: 'Belarus',
    value: 'Belarus',
    key: 'BY',
  },
  {
    text: 'Belgium',
    value: 'Belgium',
    key: 'BE',
  },
  {
    text: 'Belize',
    value: 'Belize',
    key: 'BZ',
  },
  {
    text: 'Benin',
    value: 'Benin',
    key: 'BJ',
  },
  {
    text: 'Bermuda',
    value: 'Bermuda',
    key: 'BM',
  },
  {
    text: 'Bhutan',
    value: 'Bhutan',
    key: 'BT',
  },
  {
    text: 'Bolivia',
    value: 'Bolivia',
    key: 'BO',
  },
  {
    text: 'Bosnia and Herzegovina',
    value: 'Bosnia and Herzegovina',
    key: 'BA',
  },
  {
    text: 'Botswana',
    value: 'Botswana',
    key: 'BW',
  },
  {
    text: 'Bouvet Island',
    value: 'Bouvet Island',
    key: 'BV',
  },
  {
    text: 'Brazil',
    value: 'Brazil',
    key: 'BR',
  },
  {
    text: 'British Indian Ocean Territory',
    value: 'British Indian Ocean Territory',
    key: 'IO',
  },
  {
    text: 'Brunei Darussalam',
    value: 'Brunei Darussalam',
    key: 'BN',
  },
  {
    text: 'Bulgaria',
    value: 'Bulgaria',
    key: 'BG',
  },
  {
    text: 'Burkina Faso',
    value: 'Burkina Faso',
    key: 'BF',
  },
  {
    text: 'Burundi',
    value: 'Burundi',
    key: 'BI',
  },
  {
    text: 'Cambodia',
    value: 'Cambodia',
    key: 'KH',
  },
  {
    text: 'Cameroon',
    value: 'Cameroon',
    key: 'CM',
  },
  {
    text: 'Canada',
    value: 'Canada',
    key: 'CA',
  },
  {
    text: 'Cape Verde',
    value: 'Cape Verde',
    key: 'CV',
  },
  {
    text: 'Cayman Islands',
    value: 'Cayman Islands',
    key: 'KY',
  },
  {
    text: 'Central African Republic',
    value: 'Central African Republic',
    key: 'CF',
  },
  {
    text: 'Chad',
    value: 'Chad',
    key: 'TD',
  },
  {
    text: 'Chile',
    value: 'Chile',
    key: 'CL',
  },
  {
    text: 'China',
    value: 'Chinese',
    key: 'CN',
  },
  {
    text: 'Christmas Island',
    value: 'Christmas Island',
    key: 'CX',
  },
  {
    text: 'Cocos (Keeling) Islands',
    value: 'Cocos (Keeling) Islands',
    key: 'CC',
  },
  {
    text: 'Colombia',
    value: 'Colombia',
    key: 'CO',
  },
  {
    text: 'Comoros',
    value: 'Comoros',
    key: 'KM',
  },
  {
    text: 'Congo',
    value: 'Congo',
    key: 'CG',
  },
  {
    text: 'Congo, The Democratic Republic of the',
    value: 'Congo, The Democratic Republic of the',
    key: 'CD',
  },
  {
    text: 'Cook Islands',
    value: 'Cook Islands',
    key: 'CK',
  },
  {
    text: 'Costa Rica',
    value: 'Costa Rica',
    key: 'CR',
  },
  {
    text: "Cote D'Ivoire",
    value: "Cote D'Ivoire",
    key: 'CI',
  },
  {
    text: 'Croatia',
    value: 'Croatia',
    key: 'HR',
  },
  {
    text: 'Cuba',
    value: 'Cuba',
    key: 'CU',
  },
  {
    text: 'Cyprus',
    value: 'Cyprus',
    key: 'CY',
  },
  {
    text: 'Czech Republic',
    value: 'Czech Republic',
    key: 'CZ',
  },
  {
    text: 'Denmark',
    value: 'Denmark',
    key: 'DK',
  },
  {
    text: 'Djibouti',
    value: 'Djibouti',
    key: 'DJ',
  },
  {
    text: 'Dominica',
    value: 'Dominica',
    key: 'DM',
  },
  {
    text: 'Dominican Republic',
    value: 'Dominican Republic',
    key: 'DO',
  },
  {
    text: 'Ecuador',
    value: 'Ecuador',
    key: 'EC',
  },
  {
    text: 'Egypt',
    value: 'Egypt',
    key: 'EG',
  },
  {
    text: 'El Salvador',
    value: 'El Salvador',
    key: 'SV',
  },
  {
    text: 'Equatorial Guinea',
    value: 'Equatorial Guinea',
    key: 'GQ',
  },
  {
    text: 'Eritrea',
    value: 'Eritrea',
    key: 'ER',
  },
  {
    text: 'Estonia',
    value: 'Estonia',
    key: 'EE',
  },
  {
    text: 'Ethiopia',
    value: 'Ethiopia',
    key: 'ET',
  },
  {
    text: 'Falkland Islands (Malvinas)',
    value: 'Falkland Islands (Malvinas)',
    key: 'FK',
  },
  {
    text: 'Faroe Islands',
    value: 'Faroe Islands',
    key: 'FO',
  },
  {
    text: 'Fiji',
    value: 'Fiji',
    key: 'FJ',
  },
  {
    text: 'Finland',
    value: 'Finland',
    key: 'FI',
  },
  {
    text: 'France',
    value: 'France',
    key: 'FR',
  },
  {
    text: 'French Guiana',
    value: 'French Guiana',
    key: 'GF',
  },
  {
    text: 'French Polynesia',
    value: 'French Polynesia',
    key: 'PF',
  },
  {
    text: 'French Southern Territories',
    value: 'French Southern Territories',
    key: 'TF',
  },
  {
    text: 'Gabon',
    value: 'Gabon',
    key: 'GA',
  },
  {
    text: 'Gambia',
    value: 'Gambia',
    key: 'GM',
  },
  {
    text: 'Georgia',
    value: 'Georgia',
    key: 'GE',
  },
  {
    text: 'Germany',
    value: 'Germany',
    key: 'DE',
  },
  {
    text: 'Ghana',
    value: 'Ghana',
    key: 'GH',
  },
  {
    text: 'Gibraltar',
    value: 'Gibraltar',
    key: 'GI',
  },
  {
    text: 'Greece',
    value: 'Greece',
    key: 'GR',
  },
  {
    text: 'Greenland',
    value: 'Greenland',
    key: 'GL',
  },
  {
    text: 'Grenada',
    value: 'Grenada',
    key: 'GD',
  },
  {
    text: 'Guadeloupe',
    value: 'Guadeloupe',
    key: 'GP',
  },
  {
    text: 'Guam',
    value: 'Guam',
    key: 'GU',
  },
  {
    text: 'Guatemala',
    value: 'Guatemala',
    key: 'GT',
  },
  {
    text: 'Guernsey',
    value: 'Guernsey',
    key: 'GG',
  },
  {
    text: 'Guinea',
    value: 'Guinea',
    key: 'GN',
  },
  {
    text: 'Guinea-Bissau',
    value: 'Guinea-Bissau',
    key: 'GW',
  },
  {
    text: 'Guyana',
    value: 'Guyana',
    key: 'GY',
  },
  {
    text: 'Haiti',
    value: 'Haiti',
    key: 'HT',
  },
  {
    text: 'Heard Island and Mcdonald Islands',
    value: 'Heard Island and Mcdonald Islands',
    key: 'HM',
  },
  {
    text: 'Holy See (Vatican City State)',
    value: 'Holy See (Vatican City State)',
    key: 'VA',
  },
  {
    text: 'Honduras',
    value: 'Honduras',
    key: 'HN',
  },
  {
    text: 'Hong Kong',
    value: 'Hong Kong',
    key: 'HK',
  },
  {
    text: 'Hungary',
    value: 'Hungary',
    key: 'HU',
  },
  {
    text: 'Iceland',
    value: 'Iceland',
    key: 'IS',
  },
  {
    text: 'India',
    value: 'India',
    key: 'IN',
  },
  {
    text: 'Indonesia',
    value: 'Indonesia',
    key: 'ID',
  },
  {
    text: 'Iran, Islamic Republic Of',
    value: 'Iran, Islamic Republic Of',
    key: 'IR',
  },
  {
    text: 'Iraq',
    value: 'Iraq',
    key: 'IQ',
  },
  {
    text: 'Ireland',
    value: 'Ireland',
    key: 'IE',
  },
  {
    text: 'Isle of Man',
    value: 'Isle of Man',
    key: 'IM',
  },
  {
    text: 'Israel',
    value: 'Israel',
    key: 'IL',
  },
  {
    text: 'Italy',
    value: 'Italy',
    key: 'IT',
  },
  {
    text: 'Jamaica',
    value: 'Jamaica',
    key: 'JM',
  },
  {
    text: 'Japan',
    value: 'Japan',
    key: 'JP',
  },
  {
    text: 'Jersey',
    value: 'Jersey',
    key: 'JE',
  },
  {
    text: 'Jordan',
    value: 'Jordan',
    key: 'JO',
  },
  {
    text: 'Kazakhstan',
    value: 'Kazakhstan',
    key: 'KZ',
  },
  {
    text: 'Kenya',
    value: 'Kenya',
    key: 'KE',
  },
  {
    text: 'Kiribati',
    value: 'Kiribati',
    key: 'KI',
  },
  {
    text: "Korea, Democratic People'S Republic of",
    value: "Korea, Democratic People'S Republic of",
    key: 'KP',
  },
  {
    text: 'Korea, Republic of',
    value: 'Korea, Republic of',
    key: 'KR',
  },
  {
    text: 'Kuwait',
    value: 'Kuwait',
    key: 'KW',
  },
  {
    text: 'Kyrgyzstan',
    value: 'Kyrgyzstan',
    key: 'KG',
  },
  {
    text: "Lao People'S Democratic Republic",
    value: "Lao People'S Democratic Republic",
    key: 'LA',
  },
  {
    text: 'Latvia',
    value: 'Latvia',
    key: 'LV',
  },
  {
    text: 'Lebanon',
    value: 'Lebanon',
    key: 'LB',
  },
  {
    text: 'Lesotho',
    value: 'Lesotho',
    key: 'LS',
  },
  {
    text: 'Liberia',
    value: 'Liberia',
    key: 'LR',
  },
  {
    text: 'Libyan Arab Jamahiriya',
    value: 'Libyan Arab Jamahiriya',
    key: 'LY',
  },
  {
    text: 'Liechtenstein',
    value: 'Liechtenstein',
    key: 'LI',
  },
  {
    text: 'Lithuania',
    value: 'Lithuania',
    key: 'LT',
  },
  {
    text: 'Luxembourg',
    value: 'Luxembourg',
    key: 'LU',
  },
  {
    text: 'Macao',
    value: 'Macao',
    key: 'MO',
  },
  {
    text: 'Macedonia, The Former Yugoslav Republic of',
    value: 'Macedonia, The Former Yugoslav Republic of',
    key: 'MK',
  },
  {
    text: 'Madagascar',
    value: 'Madagascar',
    key: 'MG',
  },
  {
    text: 'Malawi',
    value: 'Malawi',
    key: 'MW',
  },
  {
    text: 'Malaysia',
    value: 'Malaysia',
    key: 'MY',
  },
  {
    text: 'Maldives',
    value: 'Maldives',
    key: 'MV',
  },
  {
    text: 'Mali',
    value: 'Mali',
    key: 'ML',
  },
  {
    text: 'Malta',
    value: 'Malta',
    key: 'MT',
  },
  {
    text: 'Marshall Islands',
    value: 'Marshall Islands',
    key: 'MH',
  },
  {
    text: 'Martinique',
    value: 'Martinique',
    key: 'MQ',
  },
  {
    text: 'Mauritania',
    value: 'Mauritania',
    key: 'MR',
  },
  {
    text: 'Mauritius',
    value: 'Mauritius',
    key: 'MU',
  },
  {
    text: 'Mayotte',
    value: 'Mayotte',
    key: 'YT',
  },
  {
    text: 'Mexico',
    value: 'Mexico',
    key: 'MX',
  },
  {
    text: 'Micronesia, Federated States of',
    value: 'Micronesia, Federated States of',
    key: 'FM',
  },
  {
    text: 'Moldova, Republic of',
    value: 'Moldova, Republic of',
    key: 'MD',
  },
  {
    text: 'Monaco',
    value: 'Monaco',
    key: 'MC',
  },
  {
    text: 'Mongolia',
    value: 'Mongolia',
    key: 'MN',
  },
  {
    text: 'Montserrat',
    value: 'Montserrat',
    key: 'MS',
  },
  {
    text: 'Morocco',
    value: 'Morocco',
    key: 'MA',
  },
  {
    text: 'Mozambique',
    value: 'Mozambique',
    key: 'MZ',
  },
  {
    text: 'Myanmar',
    value: 'Myanmar',
    key: 'MM',
  },
  {
    text: 'Namibia',
    value: 'Namibia',
    key: 'NA',
  },
  {
    text: 'Nauru',
    value: 'Nauru',
    key: 'NR',
  },
  {
    text: 'Nepal',
    value: 'Nepal',
    key: 'NP',
  },
  {
    text: 'Netherlands',
    value: 'Netherlands',
    key: 'NL',
  },
  {
    text: 'Netherlands Antilles',
    value: 'Netherlands Antilles',
    key: 'AN',
  },
  {
    text: 'New Caledonia',
    value: 'New Caledonia',
    key: 'NC',
  },
  {
    text: 'New Zealand',
    value: 'New Zealand',
    key: 'NZ',
  },
  {
    text: 'Nicaragua',
    value: 'Nicaragua',
    key: 'NI',
  },
  {
    text: 'Niger',
    value: 'Niger',
    key: 'NE',
  },
  {
    text: 'Nigeria',
    value: 'Nigeria',
    key: 'NG',
  },
  {
    text: 'Niue',
    value: 'Niue',
    key: 'NU',
  },
  {
    text: 'Norfolk Island',
    value: 'Norfolk Island',
    key: 'NF',
  },
  {
    text: 'Northern Mariana Islands',
    value: 'Northern Mariana Islands',
    key: 'MP',
  },
  {
    text: 'Norway',
    value: 'Norway',
    key: 'NO',
  },
  {
    text: 'Oman',
    value: 'Oman',
    key: 'OM',
  },
  {
    text: 'Pakistan',
    value: 'Pakistan',
    key: 'PK',
  },
  {
    text: 'Palau',
    value: 'Palau',
    key: 'PW',
  },
  {
    text: 'Palestinian Territory, Occupied',
    value: 'Palestinian Territory, Occupied',
    key: 'PS',
  },
  {
    text: 'Panama',
    value: 'Panama',
    key: 'PA',
  },
  {
    text: 'Papua New Guinea',
    value: 'Papua New Guinea',
    key: 'PG',
  },
  {
    text: 'Paraguay',
    value: 'Paraguay',
    key: 'PY',
  },
  {
    text: 'Peru',
    value: 'Peru',
    key: 'PE',
  },
  {
    text: 'Philippines',
    value: 'Philippines',
    key: 'PH',
  },
  {
    text: 'Pitcairn',
    value: 'Pitcairn',
    key: 'PN',
  },
  {
    text: 'Poland',
    value: 'Poland',
    key: 'PL',
  },
  {
    text: 'Portugal',
    value: 'Portugal',
    key: 'PT',
  },
  {
    text: 'Puerto Rico',
    value: 'Puerto Rico',
    key: 'PR',
  },
  {
    text: 'Qatar',
    value: 'Qatar',
    key: 'QA',
  },
  {
    text: 'Reunion',
    value: 'Reunion',
    key: 'RE',
  },
  {
    text: 'Romania',
    value: 'Romania',
    key: 'RO',
  },
  {
    text: 'Russian Federation',
    value: 'Russian Federation',
    key: 'RU',
  },
  {
    text: 'RWANDA',
    value: 'RWANDA',
    key: 'RW',
  },
  {
    text: 'Saint Helena',
    value: 'Saint Helena',
    key: 'SH',
  },
  {
    text: 'Saint Kitts and Nevis',
    value: 'Saint Kitts and Nevis',
    key: 'KN',
  },
  {
    text: 'Saint Lucia',
    value: 'Saint Lucia',
    key: 'LC',
  },
  {
    text: 'Saint Pierre and Miquelon',
    value: 'Saint Pierre and Miquelon',
    key: 'PM',
  },
  {
    text: 'Saint Vincent and the Grenadines',
    value: 'Saint Vincent and the Grenadines',
    key: 'VC',
  },
  {
    text: 'Samoa',
    value: 'Samoa',
    key: 'WS',
  },
  {
    text: 'San Marino',
    value: 'San Marino',
    key: 'SM',
  },
  {
    text: 'Sao Tome and Principe',
    value: 'Sao Tome and Principe',
    key: 'ST',
  },
  {
    text: 'Saudi Arabia',
    value: 'Saudi Arabia',
    key: 'SA',
  },
  {
    text: 'Senegal',
    value: 'Senegal',
    key: 'SN',
  },
  {
    text: 'Serbia and Montenegro',
    value: 'Serbia and Montenegro',
    key: 'CS',
  },
  {
    text: 'Seychelles',
    value: 'Seychelles',
    key: 'SC',
  },
  {
    text: 'Sierra Leone',
    value: 'Sierra Leone',
    key: 'SL',
  },
  {
    text: 'Singapore',
    value: 'Singapore',
    key: 'SG',
  },
  {
    text: 'Slovakia',
    value: 'Slovakia',
    key: 'SK',
  },
  {
    text: 'Slovenia',
    value: 'Slovenia',
    key: 'SI',
  },
  {
    text: 'Solomon Islands',
    value: 'Solomon Islands',
    key: 'SB',
  },
  {
    text: 'Somalia',
    value: 'Somalia',
    key: 'SO',
  },
  {
    text: 'South Africa',
    value: 'South Africa',
    key: 'ZA',
  },
  {
    text: 'South Georgia and the South Sandwich Islands',
    value: 'South Georgia and the South Sandwich Islands',
    key: 'GS',
  },
  {
    text: 'Spain',
    value: 'Spain',
    key: 'ES',
  },
  {
    text: 'Sri Lanka',
    value: 'Sri Lanka',
    key: 'LK',
  },
  {
    text: 'Sudan',
    value: 'Sudan',
    key: 'SD',
  },
  {
    text: 'Suritext',
    value: 'Suritext',
    key: 'SR',
  },
  {
    text: 'Svalbard and Jan Mayen',
    value: 'Svalbard and Jan Mayen',
    key: 'SJ',
  },
  {
    text: 'Swaziland',
    value: 'Swaziland',
    key: 'SZ',
  },
  {
    text: 'Sweden',
    value: 'Sweden',
    key: 'SE',
  },
  {
    text: 'Switzerland',
    value: 'Switzerland',
    key: 'CH',
  },
  {
    text: 'Syrian Arab Republic',
    value: 'Syrian Arab Republic',
    key: 'SY',
  },
  {
    text: 'Republic of China',
    value: 'Republic of China',
    key: 'TW',
  },
  {
    text: 'Tajikistan',
    value: 'Tajikistan',
    key: 'TJ',
  },
  {
    text: 'Tanzania, United Republic of',
    value: 'Tanzania, United Republic of',
    key: 'TZ',
  },
  {
    text: 'Thailand',
    value: 'Thailand',
    key: 'TH',
  },
  {
    text: 'Timor-Leste',
    value: 'Timor-Leste',
    key: 'TL',
  },
  {
    text: 'Togo',
    value: 'Togo',
    key: 'TG',
  },
  {
    text: 'Tokelau',
    value: 'Tokelau',
    key: 'TK',
  },
  {
    text: 'Tonga',
    value: 'Tonga',
    key: 'TO',
  },
  {
    text: 'Trinidad and Tobago',
    value: 'Trinidad and Tobago',
    key: 'TT',
  },
  {
    text: 'Tunisia',
    value: 'Tunisia',
    key: 'TN',
  },
  {
    text: 'Turkey',
    value: 'Turkey',
    key: 'TR',
  },
  {
    text: 'Turkmenistan',
    value: 'Turkmenistan',
    key: 'TM',
  },
  {
    text: 'Turks and Caicos Islands',
    value: 'Turks and Caicos Islands',
    key: 'TC',
  },
  {
    text: 'Tuvalu',
    value: 'Tuvalu',
    key: 'TV',
  },
  {
    text: 'Uganda',
    value: 'Uganda',
    key: 'UG',
  },
  {
    text: 'Ukraine',
    value: 'Ukraine',
    key: 'UA',
  },
  {
    text: 'United Arab Emirates',
    value: 'United Arab Emirates',
    key: 'AE',
  },
  {
    text: 'United Kingdom',
    value: 'United Kingdom',
    key: 'GB',
  },
  {
    text: 'United States',
    value: 'United States',
    key: 'US',
  },
  {
    text: 'United States Minor Outlying Islands',
    value: 'United States Minor Outlying Islands',
    key: 'UM',
  },
  {
    text: 'Uruguay',
    value: 'Uruguay',
    key: 'UY',
  },
  {
    text: 'Uzbekistan',
    value: 'Uzbekistan',
    key: 'UZ',
  },
  {
    text: 'Vanuatu',
    value: 'Vanuatu',
    key: 'VU',
  },
  {
    text: 'Venezuela',
    value: 'Venezuela',
    key: 'VE',
  },
  {
    text: 'Viet Nam',
    value: 'Viet Nam',
    key: 'VN',
  },
  {
    text: 'Virgin Islands, British',
    value: 'Virgin Islands, British',
    key: 'VG',
  },
  {
    text: 'Virgin Islands, U.S.',
    value: 'Virgin Islands, U.S.',
    key: 'VI',
  },
  {
    text: 'Wallis and Futuna',
    value: 'Wallis and Futuna',
    key: 'WF',
  },
  {
    text: 'Western Sahara',
    value: 'Western Sahara',
    key: 'EH',
  },
  {
    text: 'Yemen',
    value: 'Yemen',
    key: 'YE',
  },
  {
    text: 'Zambia',
    value: 'Zambia',
    key: 'ZM',
  },
  {
    text: 'Zimbabwe',
    value: 'Zimbabwe',
    key: 'ZW',
  },
];
